import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { NotificationService, Notification, NotificationConfig } from '../../../services/notification.service';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-notification-container',
  templateUrl: './notification-container.component.html',
  styleUrls: ['./notification-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationContainerComponent implements OnInit, OnDestroy {
  notifications$: Observable<Notification[]>;
  config: NotificationConfig;
  private subscription: Subscription = new Subscription();

  constructor(private notificationService: NotificationService) {
    this.notifications$ = this.notificationService.getNotifications();
    this.config = this.notificationService.getConfig();
  }

  ngOnInit(): void {
    // Configurar posicionamento
    this.setupPositioning();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  /**
   * Remove uma notificação
   */
  removeNotification(id: string): void {
    this.notificationService.remove(id);
  }

  /**
   * Executa uma ação de notificação
   */
  executeAction(notification: Notification, action: any): void {
    action.action();
  }

  /**
   * Obtém classes CSS para a notificação
   */
  getNotificationClasses(notification: Notification): string {
    const baseClasses = 'notification-item';
    const typeClass = `notification-${notification.type}`;
    const positionClass = `notification-${this.config.position}`;
    const animationClass = `notification-${this.config.animation}`;
    
    return `${baseClasses} ${typeClass} ${positionClass} ${animationClass}`;
  }

  /**
   * Obtém classes CSS para o container
   */
  getContainerClasses(): string {
    return `notification-container notification-${this.config.position}`;
  }

  /**
   * Configura o posicionamento das notificações
   */
  private setupPositioning(): void {
    const container = document.querySelector('.notification-container');
    if (container) {
      container.classList.add(`notification-${this.config.position}`);
    }
  }

  /**
   * Obtém ícone para o tipo de notificação
   */
  getNotificationIcon(type: Notification['type']): string {
    const icons = {
      success: 'check_circle',
      error: 'error',
      warning: 'warning',
      info: 'info'
    };
    return icons[type];
  }

  /**
   * Obtém cor para o tipo de notificação
   */
  getNotificationColor(type: Notification['type']): string {
    const colors = {
      success: '#28a745',
      error: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8'
    };
    return colors[type];
  }

  /**
   * TrackBy function para otimizar performance
   */
  trackByNotificationId(index: number, notification: Notification): string {
    return notification.id;
  }
}
